import { useState } from 'react'
import { Create, useTranslate } from 'react-admin'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import PackageForm from '../PackageForm/PackageForm'

const PackageCreate = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)

    return (
        <>
            <BackFromEditorButton isPristineForm={isPristineForm} backToRouteURL="/package" />
            <Create title={translate('manager.resources.package.create_a_package')} {...props}>
                <PackageForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                    {...props}
                />
            </Create>
        </>
    )
}

export default PackageCreate
